import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextLink from "@streeteasy/design-system/deprecated/actions/text-link";
import { PrimaryMedium } from "@streeteasy/design-system/typography";
import { arrayOf, object, string } from "prop-types";

import GlobalState from "src/shared/utilities/globalState";

import * as propTypes from "../../propTypes";
import { setCurrentUserId } from "../../redux/slices/userIdSlice";
import getSavedSearchesUrl from "../../utilities/getSavedSearchesUrl";
import RecentSearchItem from "../RecentSearchItem";
import * as S from "./styled";

const RecentSearches = ({ recentSearches, user, userRole }) => {
  const dispatch = useDispatch();
  const { userId } = useSelector(state => state.userId);

  const handleAnalyticsSeeAllClick = () => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "homepage",
      event_action: "my_activity",
      event_label: "click"
    });
  };

  useEffect(() => {
    if (sessionStorage.getItem("isSavedSearch")) {
      GlobalState.set("toast", undefined);
    }

    dispatch(setCurrentUserId(user?.id));
  }, []);

  return (
    <S.RecentSearchesContainer>
      <PrimaryMedium>See what’s new</PrimaryMedium>
      <S.RecentSearchItems>
        {recentSearches.map(
          (recentSearch, index) =>
            index <= 2 && (
              <RecentSearchItem
                key={recentSearch.id}
                isSaved={recentSearch.isSaved}
                recentSearch={recentSearch}
              />
            )
        )}
      </S.RecentSearchItems>
      {userId && getSavedSearchesUrl(userRole) !== null && (
        <TextLink
          href={getSavedSearchesUrl(userRole)}
          onClick={handleAnalyticsSeeAllClick}
        >
          Catch up on all saves and views
        </TextLink>
      )}
    </S.RecentSearchesContainer>
  );
};

RecentSearches.defaultProps = {
  user: null,
  userRole: null
};

RecentSearches.propTypes = {
  user: propTypes.user,
  userRole: string,
  recentSearches: arrayOf(object).isRequired
};

export default RecentSearches;
